<script setup lang="ts">
import { mdiFileDocumentCheckOutline } from '@quasar/extras/mdi-v7';
import BButton from '../base/BButton/BButton.vue';
interface Props {
  actionBtnLabel?: string;
  bannerIcon?: string;
  color?: 'positive-light' | 'negative-light';
}

withDefaults(defineProps<Props>(), {
  actionBtnLabel: 'NEXT_STEP',
  bannerIcon: `${mdiFileDocumentCheckOutline}`,
  color: 'positive-light',
});

const emits = defineEmits<{
  completionAction: [];
}>();
</script>

<template>
  <section>
    <q-card
      class="column justify-center q-pa-md rounded-borders-lg"
      style="height: 50vh"
      :class="`bg-${color} text-dark`"
    >
      <q-card-section class="text-center text-h5 text-bold">
        <slot name="header">
          {{ $t('COMPLETED_STEP_BANNER_TEXT') }}
        </slot>
      </q-card-section>
      <q-card-section class="text-center text-h6">
        <slot name="message">
          {{ $t('COMPLETED_STEP_BANNER_MESSAGE') }}
        </slot>
      </q-card-section>
      <q-card-section class="row justify-center"> </q-card-section>
    </q-card>
    <div class="row justify-center q-mt-md">
      <slot name="action">
        <BButton
          color="secondary"
          size="sm"
          class="q-px-xl text-bold"
          @click="emits('completionAction')"
        >
          <span class="text-dark">{{ $t(actionBtnLabel) }}</span>
        </BButton>
      </slot>
    </div>
  </section>
</template>
